import { createFileRoute } from '@tanstack/react-router'

import { AccountingAccounts } from '@/features/accounting/pages/accounts'
import Head from '@/lib/navigation/head'

/** The page owns its wrapper and sticky header: the "Add account" button lives in the header row. */
function AccountsRoute() {
  return (
    <>
      <Head>
        <title>Connections | Nonresident Tax</title>
      </Head>
      <AccountingAccounts />
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/accounts/')({
  component: AccountsRoute,
})
